import { render } from "./CarouselItem.vue?vue&type=template&id=6fed3ebf&scoped=true"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import "./CarouselItem.vue?vue&type=style&index=0&id=6fed3ebf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fed3ebf"]])

export default __exports__